var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"com-toast-slidedown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"com-toast",class:[
      _vm.position == 'top' ? 'pos-top' : '',
      _vm.position == 'middle' ? 'pos-middle' : '',
      _vm.type,
      _vm.showTime ? 'show-time' : '',
    ]},[_c('p',{staticClass:"com-toast-content"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }